// src/config.js
// Baked in at build time by Create React App - set REACT_APP_API_BASE_URL
// when building the Docker image so the same codebase can target local dev,
// the beta subdomain, or prod without code changes.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8001/api';

export default API_BASE_URL;
export const VAT_RATE = 0.23; // 23%
